// extracted by mini-css-extract-plugin
module.exports = {"MainOurServiceRoundBox":"MainOurServiceRoundBox_MainOurServiceRoundBox__2nz7f","badge":"MainOurServiceRoundBox_badge__1Iyeg","message":"MainOurServiceRoundBox_message__3GlzJ"};